<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="entityResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"  :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" :inlineActionsDisabled="prop_inline!=='1'"
                                        :import-enabled="prop_import==='1'"
                                        :export-disabled="prop_export!=='1'"
                                       checkboxColumnDisabled editDisable withCustomRowActions>
                                <template slot="customRowActions" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="task"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="$_emWorkflowListMixin_handleApprove(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
    </div>
</template>
<script>
    // Author YuJiaBei
    // Date 2020-07-09 15:09:42

    import emWorkflowListMixin from "@/mixin/em/workflow/list";

    export default {
        name: "emWorkflowListView",
        mixins: [emWorkflowListMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            },
            //是否启用导入
            prop_import: {
                type: String,
                default: "0"
            },
            //是否启用导出
            prop_export: {
                type: String,
                default: "0"
            }
        },
    };
</script>